import styled from "styled-components";
import {GameJackpotBarContributionAmountDefaultBox} from "./game-jackpot-bar-contribution-amount.default.box";

export const GameJackpotBarContributionAmountCasino777Box = styled(GameJackpotBarContributionAmountDefaultBox)`
    color: ${({theme, isOptInStatus}) => isOptInStatus ? theme.colors.moneyColor : theme.colors.brandSecondaryDark};
`;

